module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browser_title":"DAILY DOWNLOAD LIMIT"},"ja":{"browser_title":"ダウンロード上限到達のお知らせ"}}')
  delete Component.options._Ctor
}
